export enum ResourceTableOption {
  Matches = "matches",
  AllResources = "allResources",
  Shortlists = "shortlists"
}

export const OPTION_ORDER: ResourceTableOption[] = [
  ResourceTableOption.Shortlists,
  ResourceTableOption.Matches,
  ResourceTableOption.AllResources
];
